module.exports = function(data) {
var __t, __p = '';
__p += '<div class="row wrap totals-cont" style="min-height: 60px; position:relative;"></div>\n';
return __p
}